// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__QLcfs","Layout__body":"Layout_Layout__body__vH0bD"};